import React from 'react';

const Footer = () => {
    return (
        <div className=" container mt-5">

            {/* Footer  */}
         <center> <small> Copyright &copy; Teachdemy 2021 </small></center>
        </div>
    );
};

export default Footer;